import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "app-ep-confirm-dialog",
  templateUrl: "./ep-confirm-dialog.component.html",
  styleUrls: ["./ep-confirm-dialog.component.scss"],
  standalone: false,
})
export class EpConfirmDialogComponent {
  /** Whether the dialog is visible */
  @Input() isOpen = false;

  /** Dialog title — defaults to 'Confirm' */
  @Input() title = "Confirm";

  /** Body message (supports multi-line via white-space: pre-line) */
  @Input() message = "";

  /** Label for the confirm (primary) button */
  @Input() confirmLabel = "OK";

  /** Label for the cancel (secondary) button. Set to '' to hide it. */
  @Input() cancelLabel = "Cancel";

  /** Variant: 'confirm' shows both buttons, 'alert' shows only the confirm button */
  @Input() variant: "confirm" | "alert" = "confirm";

  /** Emits when the user clicks the confirm button */
  @Output() confirmed = new EventEmitter<void>();

  /** Emits when the user clicks cancel or the overlay */
  @Output() cancelled = new EventEmitter<void>();

  onConfirm() {
    this.confirmed.emit();
  }

  onCancel() {
    this.cancelled.emit();
  }

  onOverlayClick(event: MouseEvent) {
    // Only close if they clicked the overlay itself, not the dialog box
    if (
      (event.target as HTMLElement).classList.contains("ep-confirm-overlay")
    ) {
      this.onCancel();
    }
  }
}
